// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__tlUuY","noInteraction":"EventWrapper_noInteraction__ZZzq2","pointerPassthrough":"EventWrapper_pointerPassthrough__1RnbV"};